import React from 'react';
import { toast } from 'react-toastify';
import api from '../irelandApi';
import { destandard, objectToFormData } from '../utils/commonFunctions';
import ToastMessage from '../components/common/toast-message';
import {
  GET_POSTCODE_PLAN_OBJECTIVE_LIST_PENDING,
  GET_POSTCODE_PLAN_OBJECTIVE_LIST_FETCHED,
  GET_POSTCODE_PLAN_OBJECTIVE_LIST_REJECTED,
  GET_POSTCODE_PLAN_OBJECTIVE_META_PENDING,
  GET_POSTCODE_PLAN_OBJECTIVE_META_FETCHED,
  GET_POSTCODE_PLAN_OBJECTIVE_META_REJECTED,
  GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_PENDING,
  GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_FETCHED,
  GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_REJECTED,
} from '../reducers/postcodePlanObjectivesReducer';

const POSTCODE_PLAN_OBJECTIVES_URL = 'api/postcodeplan_objectives';

const preparePostcodeplanObjectiveSubmissionPayload = (payload) => {
  const postcodeplanObjectiveSubmissionData = destandard(payload);
  const brands = postcodeplanObjectiveSubmissionData.brands ? Object.entries(postcodeplanObjectiveSubmissionData.brands)
    .map(([key, value]) => ({ brand_id: key, number_of_packs_sold: value })) : [];
  const categories = postcodeplanObjectiveSubmissionData.categories ? Object.entries(postcodeplanObjectiveSubmissionData.categories)
    .map(([key, value]) => ({ category_id: key, number_of_packs_sold: value })) : [];
  postcodeplanObjectiveSubmissionData.submissions_packs_sold_attributes = brands.concat(categories);
  delete postcodeplanObjectiveSubmissionData.proof_of_purchases;
  postcodeplanObjectiveSubmissionData.proof_of_purchases_attributes =
    Object.assign({}, ...postcodeplanObjectiveSubmissionData.proof_of_purchases_attributes);

  return objectToFormData(postcodeplanObjectiveSubmissionData, 'submission');
};

export const getPostcodePlanObjectives = () => (dispatch) => {
  dispatch({ type: GET_POSTCODE_PLAN_OBJECTIVE_LIST_PENDING });

  return api.get(POSTCODE_PLAN_OBJECTIVES_URL)
    .then((response) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVE_LIST_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVE_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const getPostcodePlanObjectiveMeta = () => (dispatch) => {
  dispatch({ type: GET_POSTCODE_PLAN_OBJECTIVE_META_PENDING });

  return api.get(`${POSTCODE_PLAN_OBJECTIVES_URL}/get_meta_opted_in`)
    .then((response) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVE_META_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVE_META_REJECTED,
        payload: error.response
      });
    });
};

export const getFilteredPostcodePlanObjectives = outletId => (dispatch) => {
  dispatch({ type: GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_PENDING });

  return api.get(`${POSTCODE_PLAN_OBJECTIVES_URL}/${outletId}/filtered_opted_in_postcodeplan_objectives`)
    .then((response) => {
      dispatch({
        type: GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_REJECTED,
        payload: error.response
      });
    });
};

export const createPostcodePlanObjectiveSubmission = payload =>
  api.post('api/submissions/create_postcodeplan_objective_submission', preparePostcodeplanObjectiveSubmissionPayload(payload))
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Submission has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message={error.response.data.message} />);

      const errorData = error.response ? { ...error.response.data.errors } : {};

      return Promise.reject(errorData);
    });



// WEBPACK FOOTER //
// ./src/actions/postcode-plan-objectives.js